import { useFormikContext, Form } from 'formik'
import { Button, TextField, Typography, Switch } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { ETranslationNs, IChallengesForm } from 'src/types'
import { HelperWrapper } from 'src/components/helper-wrapper'

import { useStyles } from '../styles'
import { TextInputWithHelper } from 'src/components/text-input-with-helper-icon'
import { Box } from '@mui/system'

import { FormDateRangePicker } from './form-date-range-picker.component'

interface IProps {
  isUpdate?: boolean
  isPaidSwitchDisabled?: boolean
  isChallangeInfoLoading?: boolean
  itemsToApprove?: number
}

export const ChallengeForm = ({
  isUpdate = false,
  isPaidSwitchDisabled,
  isChallangeInfoLoading,
  itemsToApprove = 0,
}: IProps) => {
  const [t] = useTranslation([ETranslationNs.Common, ETranslationNs.Form])
  const { errors, values, handleChange, isSubmitting, dirty, setFieldValue, handleBlur, touched } =
    useFormikContext<IChallengesForm>()
  const classes = useStyles()

  return (
    <Form className={`${classes.formWrapper} ${classes.formWrapperWithHeight}`}>
      <div className={classes.inputsWrapper}>
        <Typography className={classes.title}>{isUpdate ? 'Update' : 'Create'}</Typography>
        <div className={classes.inputsWrapper}>
          <FormDateRangePicker startField="start_date" endField="end_date" />

          <TextInputWithHelper
            inputName="name"
            handleChange={handleChange}
            handleBlur={handleBlur}
            value={values.name}
            inputUpperLabel={
              <HelperWrapper
                t={'challenges-name-input-label'}
                ns={ETranslationNs.Common}
                isInputLable
                isMandatory
              />
            }
            inputPlaceholder={t('challenges-name-input-placeholder.v', {
              ns: ETranslationNs.Common,
            })}
            error={touched.name && errors.name ? <HelperWrapper t={errors.name} /> : null}
            fullWidth
            withoutPlaceholderPrepend
          />
          <TextInputWithHelper
            inputName="description"
            handleChange={handleChange}
            handleBlur={handleBlur}
            value={values.description}
            inputUpperLabel={
              <HelperWrapper
                t={'challenges-description-input-label'}
                ns={ETranslationNs.Common}
                isInputLable
                isMandatory
              />
            }
            inputPlaceholder={t('challenges-description-input-placeholder.v', {
              ns: ETranslationNs.Common,
            })}
            error={
              touched.description && errors.description ? (
                <HelperWrapper t={errors.description} />
              ) : null
            }
            fullWidth
            withoutPlaceholderPrepend
          />

          <TextField
            autoComplete="off"
            variant="standard"
            id="trai_pool"
            name="trai_pool"
            onChange={handleChange}
            type="number"
            label={t('challenges-trai-pool-input-label.v')}
            value={values.trai_pool}
            helperText={
              <Typography className={classes.warningText}>
                {errors.trai_pool && <HelperWrapper t={errors.trai_pool} />}&nbsp;
              </Typography>
            }
          />

          {isUpdate && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <Typography>
                <HelperWrapper t={'challenges-paid-input-label'} />
              </Typography>
              <Switch
                size="small"
                checked={values.paid}
                disabled={isPaidSwitchDisabled}
                onChange={(e) => setFieldValue('paid', e.target.checked)}
              />
              {!isChallangeInfoLoading && itemsToApprove > 0 && (
                <Typography variant="caption" color="error">
                  {itemsToApprove} Pending Scans still
                </Typography>
              )}
            </Box>
          )}
        </div>
      </div>
      <Button
        variant="contained"
        disabled={isSubmitting || !dirty || Object.keys(errors).length > 0}
        type="submit"
      >
        <HelperWrapper t="save-button-text" />
      </Button>
    </Form>
  )
}
